import _ from 'lodash'
import { createSelector } from 'reselect'

const getCurrentClient = redux =>
  _.get(redux, 'globalVars.params.clientName')

const getModalPatientFormClient = redux =>
  _.get(redux, 'patientForm.clientName')

export const getGlobalVarsClients = redux =>
  _.get(redux, 'globalVars.clients', [])

// export getUserAvailableClients = redux

export const getDivisions = createSelector(
  [ getCurrentClient, getModalPatientFormClient, getGlobalVarsClients ],
  (client, modalClient, clients) =>
    _.chain(clients)
      .find(c => c.clientName === client || c.clientName === modalClient)
      .get('divisions', [])
      .map(d => _.get(d, 'name'))
      .value()
)
